export const ADMIN_CRON_CARGILL_EMAIL_PATTERN = /^[a-z0-9!#$%&'*+/=?^_`{|}~.-]+@cargill\.com$/i;
export const ADMIN_CRON_CARGILL_EMAIL_ERROR = "Enter one valid @cargill.com email address.";
